import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@bca-shared/shared.module';
import { TruncatePipe } from '@bca-verify/pipes/truncate.pipe';
import { ActionCodeComponent } from '@bca-verify/verify/action-code/action-code.component';
import { CompanyInfoComponent } from '@bca-verify/verify/company-info/company-info.component';
import { ProductSummaryComponent } from '@bca-verify/verify/product-summary/product-summary.component';
import { ProductAddonComponent } from '@bca-verify/verify/product-summary/product/product-addon/product-addon.component';
import { ProductComponent } from '@bca-verify/verify/product-summary/product/product.component';
import { VerifyComponent } from '@bca-verify/verify/verify.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    VerifyComponent,
    ProductSummaryComponent,
    ProductComponent,
    ProductAddonComponent,
    CompanyInfoComponent,
    ActionCodeComponent,
    TruncatePipe
  ],
  imports: [CommonModule, SharedModule, FormsModule, TranslateModule.forChild()],
  exports: [VerifyComponent, CompanyInfoComponent, ProductComponent, ProductAddonComponent, TruncatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VerifyModule {}
